module.exports = __webpack_public_path__ + "img/adizero.4bb437bf.png";